import { AnalyticsEvent, AnalyticsEventTemplate, EventName } from './analytics-event';

export class DownloadEvent implements AnalyticsEvent {
  event: EventName = 'download';

  download_text?: string;
  field_name?: string;

  constructor(template: AnalyticsEventTemplate<DownloadEvent> = {}) {
    Object.assign(this, template);
  }
}
